import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { RequestService } from '../services/request.service';
import { SnackService } from '../services/snack.service';
import UserHelper from '../helpers/user-helper';
import { User } from '../model/user';
import { SubscriptionBasedComponent } from '../subscription-helpers/subscription-based.component';
import { ClientCompanySelectService } from '../services/client-company-select.service';
import Company from '../model/company/company';
import { ModalService } from '../services/modal.service';
import * as globals from '../../globals/globals';
import { FileHelper } from '../helpers/file-helper';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  projectNumber: number;
  user: User;
  selectedCompany: Company;
  showToPlacerView: boolean = false;
  isImage = FileHelper.isImage;

  PRODUCTION = globals.production;

  constructor(
    public loadingService: LoadingService,
    private authService: AuthService,
    private requestService: RequestService,
    private snackService: SnackService,
    private router: Router,
    private modalService: ModalService,
    protected clientCompanySelectService: ClientCompanySelectService
  ) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.authService.getCurrentUser(),
      (res) => {
        if (res != null && res.body != null) {
          this.user = res.body;
          this.showToPlacerView = UserHelper.isPlacer(this.user);
        } else {
          this.authService.logout();
          this.router.navigateByUrl('/login');
        }
      },
      (err) => {
        if (err.status === 401) {
          this.authService.logout();
          this.router.navigateByUrl('/login');
        }
      }
    );
    this.addSubscription(
      this.clientCompanySelectService.getSelectionChangedSubscribable(),
      (res: Company) => {
        this.selectedCompany = res;
      }
    );
    this.addSubscription(this.authService.getAndSetEvent, (user) => {
      this.user = user;
      this.showToPlacerView = UserHelper.isPlacer(this.user);
    });
    this.addSubscription(this.authService.impersonationChange, () => {
      this.impersonationChange();
    });
    this.clientCompanySelectService.fetchSelectableCompanies();
  }

  impersonationChange() {
    this.addSubscription(this.authService.getCurrentUser(), (res) => {
      this.user = res.body;
      this.showToPlacerView = UserHelper.isPlacer(this.user);
      this.clientCompanySelectService.fetchSelectableCompanies();
    });
  }

  public logout() {
    this.authService.logout();
    this.router.navigateByUrl('/login');
  }

  public users() {
    this.router.navigateByUrl('/users');
  }

  public employees() {
    this.router.navigateByUrl('/users/employees');
  }

  public profile() {
    this.router.navigateByUrl('users/edit/' + this.user.id);
  }

  public clientPortalConfiguration() {
    this.router.navigateByUrl('config/client-portal');
  }

  public stopImpersonate() {
    this.modalService.confirmDialog(
      'Nabootsing stoppen',
      'Bent u zeker dat u de nabootsing wilt stoppen?',
      (b) => {
        if (b) {
          this.authService.stopImpersonate();
        }
      }
    );
  }

  toPlacerView() {
    this.modalService.confirmDialog(
      'Naar installateursportaal',
      'Bent u zeker dat u naar het installateursportaal wilt gaan?',
      (b) => {
        if (b) {
          this.router.navigateByUrl('/installateur');
        }
      }
    );
  }

  keyPress(event) {
    if (event.code === 'Enter' || event.code === 'NumpadEnter') {
      this.navigateToProject();
    }
  }

  navigateToProject() {
    this.checkIfExists();
  }

  checkIfExists() {
    this.requestService.get('/projects/exists/' + this.projectNumber).subscribe(
      (data) => {
        if (data.body) {
          this.router.navigateByUrl(
            this.getProjectRoute(data.body.ipboardProject) +
              this.projectNumber +
              '/' +
              data.body.toOpenSubProjectId
          );
        } else {
          this.snackService.showError(
            'Project met id ' + this.projectNumber + ' bestaat niet'
          );
        }
      },
      () => this.snackService.showError('Job niet gevonden')
    );
  }

  getLettres() {
    if (this.user == null) {
      return '';
    }
    return UserHelper.getLettres(this.user);
  }

  isAdmin(): boolean {
    if (this.user == null) {
      return false;
    }
    return UserHelper.isAdmin(this.user);
  }

  isClient(): boolean {
    if (this.user == null) {
      return false;
    }
    return UserHelper.isClient(this.user);
  }

  isImpersonating(): boolean {
    return this.authService.isImpersonating();
  }

  getProjectRoute(isIPBoardProject = false) {
    return this.isClient()
      ? '/klant-opdracht/'
      : isIPBoardProject
      ? '/job/'
      : '/project/';
  }

  get selectableCompanies(): Company[] {
    return this.clientCompanySelectService.getSelectableCompanies();
  }

  onSelectedCompanyChange(): void {
    this.clientCompanySelectService.selectCompany(this.selectedCompany);
    const currentRoute = this.router.url;
    if (
      this.selectedCompany.pendingInvoices &&
      currentRoute !== '/client-corner/lopende'
    ) {
      this.router.navigateByUrl('/client-corner/lopende');
    }
  }

  compareCompanies(c1: Company, c2: Company): boolean {
    if (c1 == null && c2 == null) {
      return true;
    } else if (c1 != null && c2 != null) {
      if (c1.id === c2.id) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  isTestEnvironment(): boolean {
    return !globals.production;
  }
}
